import { FC } from 'react';
import { IonCard, IonCardContent, IonRow } from '@ionic/react';
import './NavCard.scss';
import { DqText } from '../dq-text';
import classnames from 'classnames';

export interface NavCardProps {
  /**
   * The icon to be displayed on the card
   */
  icon: JSX.Element;
  /**
   * The title of the card
   */
  title: string;
  /**
   * The subtitle of the card
   */
  subtitle: string;
}

const NavCard: FC<NavCardProps> = ({ icon, title, subtitle }) => {
  return (
    <IonCard className="nav-card">
      <IonCardContent className="nav-card-content">
        {icon}
        <IonRow className="nav-card-row nav-card-title">
          <DqText variant="h3">{title}</DqText>
        </IonRow>
        <IonRow class={classnames('nav-card-row', 'nav-card-subtitle')}>
          <DqText variant="body-small">{subtitle}</DqText>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};

export default NavCard;
